import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

interface ServiceIconProps {
  color?: string;
  size?: number;
  [x: string]: unknown;
}

const ServiceIcon = ({ color, size = 24, ...rest }: ServiceIconProps) => {
  const { token } = useToken();

  const iconColor = color ?? token.colorTextTertiary;

  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="Service">
        <path
          id="ic/16px/service"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.9489 14.2637C14.8608 15.0738 17.1551 14.6995 18.7137 13.141C20.2722 11.5825 20.6464 9.28812 19.8364 7.37623L16.3926 10.82L13.6074 8.03471L17.0511 4.59097C15.1392 3.78089 12.8449 4.15512 11.2863 5.71365C9.7278 7.27217 9.35357 9.56652 10.1636 11.4784L5.38381 16.2582C4.79803 16.844 4.79803 17.7938 5.38381 18.3796L6.04775 19.0435C6.63354 19.6293 7.58328 19.6293 8.16907 19.0435L12.9489 14.2637ZM18.7137 5.71365L18.7237 5.72372L18.7036 5.7036L18.7137 5.71365Z"
          fill={iconColor}
        />
      </g>
    </svg>
  );
};

export default ServiceIcon;
